export default {
    header: "{name} 的订单",
    error: "发生错误",
    empty: "未找到订单",
    system: "服务台",
    orders: {
        name: "姓名",
        date: "日期",
        status: "地位",
        approvedBy: "批准"
    },
    cta: {
        close: "关闭"
    }
}